import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const channelInfo: Record<string, { tooltip: string; className: string }> = {
  direct: {
    tooltip:
      "Direct traffic — visitors typed the URL or used a bookmark.",
    className: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
  },
  organic: {
    tooltip: "Organic traffic from unpaid search engine results.",
    className:
      "bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300",
  },
  social: {
    tooltip: "Social traffic from social media platforms.",
    className:
      "bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300",
  },
  email: {
    tooltip: "Email traffic from campaigns or newsletter links.",
    className:
      "bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-300",
  },
  referral: {
    tooltip: "Referral traffic from external website links.",
    className:
      "bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-300",
  },
};

export const ChannelBadge = ({ channel }: { channel: string }) => {
  const info = channelInfo[channel] ?? {
    tooltip: channel,
    className: "bg-muted text-muted-foreground",
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "inline-block px-2 py-1 rounded text-xs font-medium cursor-default",
            info.className,
          )}
        >
          {channel}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">{info.tooltip}</TooltipContent>
    </Tooltip>
  );
};
